var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.0268704C19.9447 -0.132724 16.8932 0.419925 14.0408 1.64944C11.1883 2.87896 8.59783 4.75825 6.43506 7.16702C4.2723 9.57579 2.58493 12.461 1.48099 15.6379C0.37704 18.8147 -0.119169 22.2133 0.0241262 25.6161C0.0241262 33.6767 5.76809 41.6094 8.64008 44.8081C11.5121 48.0067 23 64 23 64C23 64 34.4879 48.0067 37.3599 44.8081C40.2319 41.6094 45.9759 33.6767 45.9759 25.6161C46.1192 22.2133 45.623 18.8147 44.519 15.6379C43.4151 12.461 41.7277 9.57579 39.5649 7.16702C37.4022 4.75825 34.8117 2.87896 31.9592 1.64944C29.1068 0.419925 26.0553 -0.132724 23 0.0268704Z",
    fill: "#79B44D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 19.1671V13.9688H26.7812V16.3661L23.5 13.3125L13 23.1562H15.625V31.6875H21.5312V25.125H25.4688V31.6875H31.375V23.1562H34L30.0625 19.1671Z",
    fill: "#80B14D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableShift);
export default __webpack_public_path__ + "static/media/available_shift.08ac8899cfe0746c5fa52b86f8d1c876.svg";
export { ForwardRef as ReactComponent };